import AlertDialog from 'ub/ui/alert-dialog';
import React from 'react';
import classnames from 'classnames';

import PageMobileTour from './mobile-tour/page-mobile-tour';
import PageActionBar from './mobile-tour/page-action-bar';
import ConvertableMobileTour from './mobile-tour/convertable-mobile-tour';
import ConvertableActionBar from './mobile-tour/convertable-action-bar';

import styles from './mobile-tour.scss';

export default function MobileTourAlertDialog(props) {
  const {
    displayNameCapitalized,
    displayNameLowerCase,
    onClose,
    showOverlaySEOWarning,
    useConvertablesMobileTour,
  } = props;

  const contentClassName = classnames({
    [styles.pageContainer]: !useConvertablesMobileTour,
    [styles.convertableContainer]: useConvertablesMobileTour,
  });

  return new AlertDialog({
    title: 'Ready to make your ' + displayNameLowerCase + ' responsive?',
    closeX: true,
    attributes: {
      className: 'modal-panel alert-modal mobile-tour',
    },
    clickOutsideWillClose: true,
    content: (
      <div className={contentClassName}>
        {
          useConvertablesMobileTour ? (
            <ConvertableMobileTour
              displayNameCapitalized={displayNameCapitalized}
              displayNameLowerCase={displayNameLowerCase}
              showOverlaySEOWarning={showOverlaySEOWarning}
            />
          ) : <PageMobileTour />
        }
      </div>
    ),
    onClose,
    containerClass: styles.container,
    actionBar: useConvertablesMobileTour ? <ConvertableActionBar /> : <PageActionBar />,
  });
}



// WEBPACK FOOTER //
// ./src/ui/alert-dialog/mobile-tour.jsx